import { useState, useEffect } from 'react';
import { Container, Typography, Table, TableBody, TableCell, TableHead, TableRow, Chip } from '@mui/material';
import api from '../services/api';

// Человекочитаемые типы действий и статусы (единый словарь с дашбордом).
const TYPE_LABEL: Record<string, string> = {
  like: 'Лайк',
  comment: 'Комментарий',
  subscribe: 'Подписка',
};
const STATUS_LABEL: Record<string, string> = {
  success: 'Успешно',
  failed: 'Ошибка',
};

export default function HistoryPage() {
  const [actions, setActions] = useState<any[]>([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get('/actions');
        setActions(res.data.data.actions);
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>История действий</Typography>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Тип</TableCell>
            <TableCell>Аккаунт</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Дата</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {actions.map(action => (
            <TableRow key={action.id}>
              <TableCell>{TYPE_LABEL[action.actionType] || action.actionType}</TableCell>
              <TableCell>{action.account?.firstName} {action.account?.lastName}</TableCell>
              <TableCell>
                <Chip
                  label={STATUS_LABEL[action.status] || action.status}
                  color={action.status === 'success' ? 'success' : 'error'}
                  size="small"
                />
              </TableCell>
              <TableCell>{new Date(action.createdAt).toLocaleString('ru-RU')}</TableCell>
            </TableRow>
          ))}
          {actions.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} align="center" sx={{ color: 'text.secondary', py: 4 }}>
                Действий пока нет
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Container>
  );
}
